/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  autopilots: []
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getAutopilots: (state) => state.autopilots,

  getAutopilotName: () => (autopilot) => {
    switch (autopilot.function) {
      case 'WorkPackageStatus':
        return 'WORKPACKAGE.status';
      case 'WorkPackageImages':
        return 'WORKPACKAGE.images';
      default:
        return 'Will';
    }
  },
};
// Actions
const actions = {
  clearAutopilots({commit}){
    commit('set_autopilots', []);
  },
  requestAutopilots({commit}, payload){
    return new Promise( (resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/autopilots?showWithEntitiesNormalized`,
        method: 'GET'
      }).then( resp => {
        console.log(resp);
        commit('set_autopilots', resp.data.data.autopilots);
        resolve();
      }).catch( () => {
        reject();
      })
    });
  },
  createAutopilot({commit}, payload){
    return new Promise( (resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/autopilots`,
        method: 'POST',
        data: { autopilot: payload.autopilot }
      }).then( () => {
        payload.selected_id = payload.autopilot;
        payload.update_key = 'selected_id';
        commit('update_autopilot', payload);
        resolve();
      }).catch( () => {
        reject();
      })
    });
  },
  updateAutopilot({commit}, payload) {
    return new Promise( (resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/autopilots/${payload.autopilot_id}`,
        method: 'PUT',
        data: { active: payload.active }
      }).then( () => {
        payload.update_key = 'active';
        commit('update_autopilot', payload);
        resolve();
      }).catch( () => {
        reject();
      })
    });
  },
  deleteAutopilot({commit}, payload) {
    return new Promise( (resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/autopilots/${payload.autopilot_id}`,
        method: 'DELETE',
      }).then( () => {
        payload.selected_id = -1;
        payload.update_key = 'selected_id';
        commit('update_autopilot', payload);
        commit('update_autopilot', {key: payload.key, update_key: 'active', active: false});
        resolve();
      }).catch( () => {
        reject();
      })
    });
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_autopilots(state, autopilots){
    state.autopilots = autopilots;
  },
  update_autopilot(state, payload){
    state.autopilots[payload.key][payload.update_key] = payload[payload.update_key];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
